import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { pagesAPI } from '../lib/api';

export default function ShippingInfoPage() {
    const [page, setPage] = useState({ title: 'Shipping Information', content: '' });
    const [, setLoading] = useState(true);

    useEffect(() => {
        fetchPage();
    }, []);

    const fetchPage = async () => {
        try {
            const response = await pagesAPI.getShippingInfo();
            if (response.data) setPage(response.data);
        } catch (error) {
            // Using default content
        } finally {
            setLoading(false);
        }
    };

    const defaultContent = `
## Shipping Information

We deliver to all major pin codes in India. 

### Delivery Partners

We partner with reputable courier services to ensure your order reaches you safely and on time:
- Delhivery
- Xpressbees
- BlueDart
- Ecom Express

### Delivery Time

- Metro Cities: 2-4 business days
- Rest of India: 4-7 business days
- Remote Areas: 7-10 business days

### Tracking

You can track your order status from the 'My Orders' section in your profile. You will also receive SMS and Email updates at every step.
  `;

    return (
        <div className="max-w-4xl mx-auto px-4 py-12" data-testid="shipping-info-page">
            <Card>
                <CardHeader>
                    <CardTitle className="text-3xl">{page.title}</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="prose prose-slate dark:prose-invert max-w-none">
                        <div className="whitespace-pre-wrap text-muted-foreground leading-relaxed">
                            {page.content || defaultContent}
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
